module.exports = __webpack_public_path__ + "img/daNang2.e32df41e.jpg";